import React from 'react';
import { connect } from 'redux-bundler-react';
import OpacitySlider from './opacity-slider';
import LabelToggle from './label-toggle';
import DownloadLayer from './download-layer';
import LayerOrder from './layer-order';
import RasterReclass from './raster-reclass';
// import ServiceInfo from './service-info';

class layerConfig extends React.Component {
  render(){
    const { tokenPayload, dsSelectedItem, doDsCloseSubPanel, viewportIsIE, dsSubPanelType, threeD } = this.props;
    let content = null
    let hasRoles = false;
    if(tokenPayload && tokenPayload.user && tokenPayload.user.ROLES) {
      hasRoles = (tokenPayload.user.ROLES).includes('ADMIN') ? true : false
    }
    
    if(dsSubPanelType === 'layerConfig') {
      content =(
        <div style={{marginTop:'6px', marginLeft:'6px'}} className='subpanel'>
          <div style={{display:'inline-flex', alignItems:'baseline'}}>
            <span 
              style={{ position:'relative', fontSize:18, cursor:'pointer' }}
            >
              <i onClick={ doDsCloseSubPanel } className="mdi mdi-arrow-left"></i>
            </span>
            <label className="control-label larger-font" style={{marginLeft:'6px'}}>{ dsSelectedItem.displayName }</label>
            
            
          </div>
              <div className="thin-scrollbar sidebar-list-new">
                
                <DownloadLayer layer={dsSelectedItem} />
                {/* <ServiceInfo layer={dsSelectedItem} /> */}
                <OpacitySlider layer={dsSelectedItem.mapLayer} isIE={viewportIsIE} />
                <LayerOrder layer={dsSelectedItem} />
                <LabelToggle layer={dsSelectedItem} />
              
              </div>
        </div>
      )
    }else if(dsSubPanelType === 'rasterReclass'){
      content=(
        <div style={{marginTop:'6px', marginLeft:'6px'}} className='subpanel'>
          <div style={{display:'inline-flex', alignItems:'baseline'}}>
            <span
              style={{ position:'relative', fontSize:18, cursor:'pointer' }}
            >
              <i onClick={ doDsCloseSubPanel } className="mdi mdi-arrow-left"></i>
            </span>
            <label className="control-label larger-font" style={{marginLeft:'6px'}}>Raster Reclass</label>            
          </div>
          <div className="thin-scrollbar sidebar-list-new" style={{height:'98%'}} >
            <RasterReclass layer={dsSelectedItem} />
          </div>
        </div>
      )
    }
    return content;    
  }
}

export default connect(
  'selectDsSelectedItem',
  'selectDsSubPanelType',
  'selectViewportIsIE',
  'doDsCloseSubPanel',
  'selectTokenPayload',
  'selectThreeD',
  layerConfig
)